import script from "./DevPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DevPanel.vue?vue&type=script&setup=true&lang=ts"

import "./DevPanel.vue?vue&type=style&index=0&id=b0f385b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0f385b8"]])

export default __exports__